import { Image, TextPassage } from '@petsmart-ui/sparky';
import { useState } from 'react';

import type { ProductPharmacyData } from '@/entities/product';
import { useVetRxContentQuery } from '@/entities/vet-rx-content';

import { PHARMACY_TYPE_DATA_MAP, sendAnalytics, vetRxTitleCats } from '../lib';
import { SpecialtyLineItem } from './SpecialtyLineItem';
import type { VetRxDrawerTypes } from './types';
import { VetRxDrawer } from './VetRxDrawer';

type VetRxLineItemProps = {
    pharmacyData: ProductPharmacyData;
};

export const VetRxLineItems = ({ pharmacyData }: VetRxLineItemProps) => {
    const { vetRx = [] } = useVetRxContentQuery();

    const { type, coldStorage } = pharmacyData;
    const [currentType, setCurrentType] = useState<VetRxDrawerTypes | null>(null);

    const pharmacyTypeDataMap = PHARMACY_TYPE_DATA_MAP[type] ?? null;

    const drawerType = coldStorage ? 'cold' : type;
    const showDrawerBtn = vetRx.some(item => item?.fields?.title === vetRxTitleCats[drawerType]);

    const handleDetailsClick = (drawerType: VetRxDrawerTypes) => {
        setCurrentType(drawerType);
        sendAnalytics(drawerType);
    };

    return (
        <>
            {pharmacyTypeDataMap && (
                <SpecialtyLineItem
                    {...pharmacyTypeDataMap}
                    role="button"
                    ariaLabel="Pharmacy information"
                    onClickAction={() => handleDetailsClick(type)}
                    shouldShowDetailsButton={showDrawerBtn}
                />
            )}
            {coldStorage && (
                <SpecialtyLineItem
                    role="button"
                    onClickAction={() => handleDetailsClick('cold')}
                    icon={'circle-snowflake'}
                    ariaLabel="Cold item information"
                    text="Cold item separate purchase necessary"
                    shouldShowDetailsButton={showDrawerBtn}
                />
            )}
            {type === 'rx_med' && (
                <TextPassage>
                    <span>Fulfilled by</span>
                    <Image
                        className="vetsource-image"
                        src="/pdp/icons/logo-vetsource.svg"
                        alt="VetSource"
                        width={96}
                        height={17}
                    />
                </TextPassage>
            )}
            <VetRxDrawer
                open={Boolean(currentType)}
                vetRx={vetRx ?? []}
                type={currentType ?? undefined}
                onCloseAction={() => setCurrentType(null)}
            />
        </>
    );
};
